module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-sponsors/event-sponsors.component.scss
// module id = ./src/app/routes/event/event-sponsors/event-sponsors.component.scss
// module chunks = 9